<body class="ltr main-body leftmenu">

    <form autocomplete="off" novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="FeeDetailForm">
                            <div class="col-lg-12 col-md-12">
                                <div class="card custom-card">
                                    <div class="card-body">
                                       
                                        <div class=" d-flex align-items-center pl-3">
                                            <img alt="Logo" src="../../assets/img/CollegeMaster.png"
                                                class="mh-45px pb-2">
                                            <div class="ml-2">
                                                <h3 class="main-content-label mb-1"><b>
                                                        Fee Details Report
                                                    </b></h3>
                                                <p class="text-muted card-sub-title mb-0">
                                                    Fee Details Report </p>
                                            </div>
                                        </div>
                                        <hr class="mt-1 mb-2">
                                        <div class="row clearfix mt-3">
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Session</mat-label>
                                                            <mat-select required #select232 placeholder="Session"
                                                                class="colorblack" formControlName="SnNo">
                                                                <mat-select-filter *ngIf="select232.focused"
                                                                    [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                                    [array]="sessionList"
                                                                    (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                                <mat-option *ngFor="let item of SessionFilterList"
                                                                    [value]="item.SnNo">
                                                                    {{item.SnName}}
                                                                </mat-option>
                                                            </mat-select>
                                                          
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                           <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Course</mat-label>
                                                        <mat-select #select22 placeholder="Course"
                                                            class="colorblack" formControlName="CoCode">
                                                            <mat-select-filter *ngIf="select22.focused"
                                                                [placeholder]="'Course'" [displayMember]="'CoName'"
                                                                [array]="courseList"
                                                                (filteredReturn)="filteredcourseList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredcourseList"
                                                                [value]="item.CoCode">
                                                                {{item.CoCode}} - {{item.CoName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> College</mat-label>
                                                        <mat-select #select225 placeholder="College Name"
                                                            class="colorblack" formControlName="CgCode">
                                                            <mat-select-filter *ngIf="select225.focused"
                                                                [placeholder]="'College Name'"
                                                                [displayMember]="'CgName'" [array]="collegeList"
                                                                (filteredReturn)="filteredCollegeList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredCollegeList"
                                                                [value]="item.CgCode">
                                                                {{item.CgCode}} - {{item.CgName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Fee Type
                                                        </mat-label>
                                                        <mat-select required #select33 class="colorblack"
                                                            formControlName="FeeType">
                                                            <mat-select-filter *ngIf="select33.focused" [placeholder]="'Filter'"
                                                                [displayMember]="'CdDesc'" [array]="feeList"
                                                                (filteredReturn)="filteredfeeList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredfeeList" [value]="item.CdCode">
                                                                {{item.CdDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="FeeDetailForm.controls['FeeType'].touched && FeeDetailForm.controls['FeeType'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                    </mat-form-field>
            
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Fee Status</mat-label>
                                                        <mat-select placeholder="College Name" class="colorblack" formControlName="FeeStatus">
                                                            <mat-option [value]="'N'">N</mat-option>
                                                            <mat-option [value]="'Y'">Y</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            
                                            <div class="row col-sm-12">
                                                <div class="col-sm-12 prpl">
                                                    <button type="button" class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                                                        (click)="back()">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="20vh" src="../../assets/img/refresh.gif">
                                                            Reset
                                                        </span>
                                                    </button>
                                                    
                                                    <button type="button" (click)="getData()"
                                                        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="15vh" src="../../assets/img/list.gif"
                                                                style="margin-right: 7px;">
                                                            List
                                                        </span>
                                                    </button>

                                                   
                                                </div>
                                            </div> 
                                        </div>
                                        <hr class="mt-3">
                                        <div class="col-sm-12 pl-0">
                                            <div *ngIf="Table">
                                                <div class="table-responsive table-container" id="table">
                                                    <table class="table table-bordered text-nowrap">
                                                        <thead>
                                                            <tr class="text-left">
                                                                <th class="f600">
                                                                    Name
                                                                </th>
                                                                <th class="f600">
                                                                    College
                                                                </th>
                                                                <th class="f600">
                                                                    Course
                                                                </th>
                                                                <th class="f600">
                                                                    Fee Template
                                                                </th>
                                                                <!-- <th class="f600">
                                                                    Fees
                                                                </th>
                                                                <th class="f600">
                                                                    Paid Fees
                                                                </th> -->
                                                                <th class="f600">
                                                                    Fee Status
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody class="curs">
                                                            <tr  *ngFor="let item of FeeData;" >
                                                                <td>{{item.StuFirstNameEng + " " + item.StuMidNameEng + " " + item.StuLastNameEng}}</td>
                                                                <td>{{item.CgName}}</td>
                                                                <td>{{item.CoCode}}</td>
                                                                <td>{{item.FeeTemplateCode}}</td>
                                                                <!-- <td>{{item.FeeAmt}}</td>
                                                                <td>{{item.TotalPaidAmount}}</td> -->
                                                                <td>{{item.FeeStatus}}</td>
                                                            </tr>
                                                            <!-- <tr class="table-total">
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td><b>Total Amount</b></td>
                                                                <td>{{TotalFees}}</td>
                                                                <td>{{TotalPaid}}</td>
                                                                <td></td>
                                                            </tr> -->
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>